<template>
  <div id="admin-config-wrapper">
    <Component class="active-component" :is="activeComponent" />
    <config-navigation :routes="routes" @navigate="navigate" />
  </div>
</template>
<script>
import ConfigNavigation from "./Components/ConfigNavigation.vue";
import Identity from "./Components/Identity.vue";
import Packages from "./Components/Packages.vue";
import Services from "./Components/Services.vue";
import AddOns from "./Components/AddOns.vue";
import Adjustments from "./Components/Adjustments.vue";
import Automations from "./Components/Automations.vue";
import Forms from "./Components/Forms.vue";
import Contracts from "./Components/Contracts.vue";
import Payments from "./Components/Payments.vue";
export default {
  data() {
    return {
      activeComponent: Identity,
      routes: [
        {
          path: "/identity",
          navigation: "Identity",
          component: Identity,
        },
        {
          path: "/packages",
          navigation: "Packages",
          component: Packages,
        },
        {
          path: "/services",
          navigation: "Services",
          component: Services,
        },
        {
          path: "/Add-Ons",
          navigation: "Add-Ons",
          component: AddOns,
        },
        {
          path: "/adjustments",
          navigation: "Adjustments",
          component: Adjustments,
        },
        {
          path: "/automations",
          navigation: "Automations",
          component: Automations,
        },
        {
          path: "/forms",
          navigation: "Forms",
          component: Forms,
        },
        {
          path: "/contracts",
          navigation: "Contracts",
          component: Contracts,
        },
        {
          path: "/payments",
          navigation: "Payments",
          component: Payments,
        },
        {
          path: "/subscription",
          navigation: "Subscription",
          component: "",
        },
      ],
    };
  },
  computed: {},
  methods: {
    navigate(route) {
      if (route.navigation === "Subscription") {
        this.$store.dispatch("stripeCreatePortal").then((res) => {
          window.location.href = res.data.url;
        });
      } else {
        this.activeComponent = route.component;
        this.$router.push("/config" + route.path);
      }
    },
  },
  created() {
    if (this.$route.path === "/config") {
      this.$router.push("/config/packages");
    }
  },
  components: {
    ConfigNavigation,
  },
  props: [],
};
</script>
<style scoped>
@media screen {
  #admin-config-wrapper {
    width: 100%;
  }

  .active-component {
    width: 100%;
    padding: 20px;
    height: 100%;
    float: left;
  }
  @media (min-width: 800px) {
    #admin-config-wrapper {
      width: 100%;
    }

    .active-component {
      width: 100%;
      padding-right: 120px;
      box-sizing: border-box;
      height: 100%;
      float: left;
    }
  }
}
</style>
